





































import {Component, Vue} from 'vue-property-decorator';
import {LayoutModule} from '@/store/modules/LayoutModule';

@Component({})
export default class ConfirmDialog extends Vue {
  loading: boolean = false;

  get dialog() {
    return LayoutModule.dialog;
  }

  async cancelAction() {
    try {
      this.loading = true;
      if (this.dialog.cancelAction) {
        await this.dialog.cancelAction();
      }
    } finally {
      LayoutModule.hideConfirmDialog();
      this.loading = false;
    }

  }

  async callAction() {
    try {
      this.loading = true;
      if (typeof (this.dialog.action) === 'function') {
        await this.dialog.action();
      }
    } finally {
      LayoutModule.hideConfirmDialog();
      this.loading = false;
    }

  }
}
